const doc = [({"zh_cn":({"adminConstantChannelManagerType":({"neppan":"Neppan", "noCollaboration":"无", "raku2":"Rakutsu", "temairazu":"Temairazu", "tlLincoln":"TL Lincoln"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;